/**
 * How the payer pays, in order. Numbered because it is a sequence: the payer does step 1 before step 2, and
 * the numbers let the person reading it to them over the phone say "now step 2".
 */
export function PaymentSteps({ title, steps }: { title: string; steps: string[] }) {
  return (
    <section className="space-y-2.5">
      <h4 className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{title}</h4>
      <ol className="space-y-2">
        {steps.map((step, index) => (
          <li key={step} className="flex items-start gap-2.5 text-sm text-foreground">
            <span
              aria-hidden="true"
              className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/10 font-mono text-[11px] font-semibold text-primary"
            >
              {index + 1}
            </span>
            <span className="min-w-0 pt-px">{step}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
